export default class CarouselIosBridge {
    /*🤫*/

    constructor(cinemaDom) {
        this.cinemaDom = cinemaDom;

        /*🤫*/
        this.xDown = null;
        this.yDown = null;
    }

    init() {
        /*🤫*/
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
            const self = this;
            this.cinemaDom.addEventListener("touchstart", (e) => self.handleTouchStart(e), {passive: true});
            this.cinemaDom.addEventListener("touchmove", (e) => self.handleTouchMove(e), {passive: false});
        }
    }

    /*🤫*/
    handleTouchStart(e) {
        const firstTouch = e.touches[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;
    }

    /*🤫*/
    handleTouchMove(e) {
        if (!this.xDown || !this.yDown) {
            return;
        }

        const xUp = e.touches[0].clientX;
        const yUp = e.touches[0].clientY;

        const xDiff = this.xDown - xUp;
        const yDiff = this.yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > 0) {
                /*🤫*/
            } else {
                /*🤫*/
            }
            e.preventDefault();
        } else {
            if (yDiff > 0) {
                /*🤫*/
            } else {
                /*🤫*/
            }
        }
        this.xDown = null;
        this.yDown = null;
    }
}